export const ApiClientPlugin = {
    install: function (Vue, { ApiClient, store = null }) {
        ApiClient.interceptors.request.use((config) => {
            const hostname = typeof window !== "undefined" ? window.location.hostname : "";
            const parts = hostname.split('.');
            const isWww = parts[0] === 'www';
            const subdomain = isWww ? parts[1] : parts[0];

            if (
                subdomain !== "mp1858" &&
                typeof window.transferState !== "undefined" &&
                window.transferState.get("i18n").locale !== "ru"
            ) {
                config.url = "/" + window.transferState.get("i18n").locale + config.url;
            }
            return config;
        });
        if (store) {
            ApiClient.interceptors.request.use((config) => {
                config.headers = {
                    ...config.headers,
                    "X-Bitrix-Csrf-Token": store.state.session_id,
                };
                return config;
            });
        }
        ApiClient.interceptors.response.use(
            function (response) {
                if (
                    Array.isArray(response.data.errors) &&
                    response.data.errors.length > 0
                ) {
                    let errorText = "";
                    if (response.data.errors[0]["code"] === "invalid_csrf") {
                        errorText = "Сессия устарела. Пожалуйста обновите страницу";
                    } else {
                        errorText =
                            typeof response.data.errors[0]["message"] !== "undefined"
                                ? response.data.errors[0]["message"]
                                : "Системная ошибка";
                    }
                    return Promise.reject(new Error(errorText));
                }
                return Promise.resolve(response.data);
            },
            function (error) {
                return Promise.reject(new Error(error.message));
            }
        );
    },
};